import { FormField } from 'global/components/Form'

interface IProps {
    placeholders?: {
        nomeResponsavel?: string
        email?: string
        telefoneResponsavel?: string
    }
}

export default function FormContato({ placeholders = {} }: IProps) {
    return (
        <>
            <FormField
                name="nomeContato"
                label="Nome do contato"
                placeholder={placeholders.nomeResponsavel}
            />
            <FormField
                name="emailContato"
                label="Email para contato"
                type="email"
                placeholder={placeholders.email}
            />
            <FormField
                name="telefoneContato"
                label="Telefone para contato (com DDD)"
                placeholder={placeholders.telefoneResponsavel}
                type="tel"
            />
        </>
    )
}
